import { render } from "./create-app.vue?vue&type=template&id=ceb19b8e"
import script from "./create-app.vue?vue&type=script&setup=true&lang=js"
export * from "./create-app.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/home/runner/work/linker-marketplace-web/linker-marketplace-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/v2/modules/integrations/pages/link-marketplace/components/shopify/create-app.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ceb19b8e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ceb19b8e', __exports__)) {
    console.log('reload')
    api.reload('ceb19b8e', __exports__)
  }
  
  module.hot.accept("./create-app.vue?vue&type=template&id=ceb19b8e", () => {
    console.log('re-render')
    api.rerender('ceb19b8e', render)
  })

}


export default __exports__